import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./auth";
import { userApi } from "./api";

const ThemeContext = createContext({ theme: "dark", setTheme: () => {} });

const STORAGE_KEY = "habbothek_theme";

const applyTheme = (theme) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (theme === "light") {
    root.classList.add("theme-light");
    root.dataset.theme = "light";
  } else {
    root.classList.remove("theme-light");
    root.dataset.theme = "dark";
  }
};

export const ThemeProvider = ({ children }) => {
  const { userToken, user } = useAuth();
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(STORAGE_KEY) || "dark";
  });

  useEffect(() => { applyTheme(theme); }, [theme]);

  // Wenn User eingeloggt und Preferences vorhanden -> sync mit Backend
  useEffect(() => {
    if (user?.preferences?.theme && user.preferences.theme !== theme) {
      setThemeState(user.preferences.theme);
      localStorage.setItem(STORAGE_KEY, user.preferences.theme);
    }
    
  }, [user?.preferences?.theme]);

  const setTheme = useCallback(async (next) => {
    setThemeState(next);
    localStorage.setItem(STORAGE_KEY, next);
    if (userToken) {
      try { await userApi(userToken).updatePreferences({ theme: next }); }
      catch (e) { /* offline ok */ }
    }
  }, [userToken]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
